import { useEffect } from "react";

/** Per-route title/description without a new dependency. */
export function usePageMeta(meta) {
  const { title, description } = meta || {};
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (m) m.setAttribute("content", description);
    }
  }, [title, description]);
}
